import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToggleService } from '@df/ui/toggle/toggle.service';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { TButtonStyles } from '../../common/buttons/button-style/button-style.component';
import { NTextComponent } from '../../common/text/text.component';

let uid = 0;

export namespace NCmsFaq {
    export interface IComponentData extends NICmsContentComponent.IData {
        alignment: 'left' | 'center';
        overline: string;
        title: string;
        copy: string;
        ctaCopy: string;
        ctaUrl: string;
        ctaStyle?: TButtonStyles;
        textComponentVariat?: 'default' | 'light';
        questions: IQuestion[];
    }

    export interface IQuestion {
        question: string;
        answer: string;
    }
}

@ICmsComponent<CmsFaqComponent>({
    id: 'faq',
    name: 'Faq',
    tags: ['faq'],
    isAdvanced: true,
    fields: [
        ...NTextComponent.getFields(),
        <NICmsContentField.IChoiceField>{
            key: 'alignment',
            type: NICmsContentField.EFieldType.choice,
            title: 'Alignment',
            options: [
                { key: 'left', title: 'Left' },
                { key: 'center', title: 'Center' }
            ],
            required: true,
            default: 'left'
        },
        <NICmsContentField.IChoiceField>{
            key: 'textComponentVariat',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text component variant',
            options: [
                { key: 'default', title: 'Default' },
                { key: 'light', title: 'Light' }
            ],
            default: 'default'
        },
        <NICmsContentField.IRepeaterField>{
            key: 'questions',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Questions',
            fields: [
                <NICmsContentField.ITextField>{
                    key: 'question',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Question',
                    required: true,
                    default: 'How are Millies cookies made?'
                },
                <NICmsContentField.ITextField>{
                    key: 'answer',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Answer',
                    required: true,
                    default: 'Our cookies are made with love and care.'
                }
            ]
        }
    ],
    priority: 50
})
@Component({
    selector: 'cms-faq',
    templateUrl: './cms-faq.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsFaqComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsFaq.IComponentData;

    private readonly _uid = `faq${uid++}`;

    protected toggleService = inject(ToggleService);

    protected get toggleGroupId(): string {
        return this._uid;
    }

    protected get firstColumnClass(): string {
        if (this.client.isS || this.client.isM) {
            return 'w-12';
        } else {
            return this.component?.alignment === 'left' ? 'w-6 p-r-5-x p-r-5-l' : 'w-12';
        }
    }

    protected get secondColumnClass(): string {
        if (this.client.isS || this.client.isM) {
            return 'w-12 m-t-10';
        } else {
            return this.component?.alignment === 'left' ? 'w-6 p-l-5-x p-l-5-l' : 'w-12 m-t-10';
        }
    }
}
